import React, { useState, useEffect, useContext, useCallback } from "react";
import { Form, Button, Row, Col } from "react-bootstrap";
import { MdArrowBack } from "react-icons/md";
import { useNavigate, useParams } from "react-router-dom";
import { Formik, Field } from "formik";
import * as Yup from "yup";
import * as apicall from "../../components/Apicall";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import DatePicker from "react-datepicker";
import { toast } from "react-toastify";
import { IoCalendarOutline } from "react-icons/io5";
import UserContext from "../../components/context/UserContext";
import { MultiSelect } from "primereact/multiselect";
import { Dropdown } from "primereact/dropdown";
import RotateDevicePopup from "../../components/RotateDevicePopup/RotateDevicePopup";
import { Country, State } from "country-state-city";

// Debounce utility function
const debounce = (func, wait) => {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), wait);
  };
};

const AddProvider = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [services, setServices] = useState([]);

  const [fileName, setFileName] = useState("");
  const [selectedService, setSelectedService] = useState([]);
  const [serviceError, setServiceError] = useState(false);

  const [feeRange, setFeeRange] = useState({ fee_from: "", fee_to: "" });
  const { vendor, refreshVendorData } = useContext(UserContext);
  const [serviceId, setServiceId] = useState("");
  const [isCheckingUser, setIsCheckingUser] = useState(false);
  const [isServicesLoading, setIsServicesLoading] = useState(false);

  const [servicesFetched, setServicesFetched] = useState(false);
  const [specializationName, setSpecializationName] = useState("");

  const IMAGE_SIZE_LIMIT = 500 * 1024;
  const IMAGE_DIMENSIONS_WIDTH = 180;
  const IMAGE_DIMENSIONS_HEIGHT = 180;

  const initialValues = {
    providerName: "",
    emailAddress: "",
    mobileNumber: "",
    gender: "",
    experienceStartDate: "",
    payRoll: "",
    service: [],
    education: "",
    address: "",
    city: "",
    state: "",
    country: "AE",
    dateOfBirth: "",
    about: "",
    uniqueId: "",
    requiredLogin: "No",
    profileImage: null,
    countryCode: "971",
    countryIso: "ae",
  };

  const [savedValues, setSavedValues] = useState(null);
  const [currency, setCurrency] = useState("AED");

  useEffect(() => {
    let userDetails = JSON.parse(localStorage.getItem("userDetails"));
    setCurrency(userDetails?.currency);
  }, []);

  useEffect(() => {
    const savedProviderDetails = sessionStorage.getItem("providerDetails");
    if (savedProviderDetails) {
      const parsedDetails = JSON.parse(savedProviderDetails);

      let s1 = [];
      for (let i of parsedDetails.service) {
        for (let j of services) {
          if (j.id === i) {
            s1.push({ id: j.id, name: j.name });
          }
        }
      }
      setSelectedService(s1);
      // console.log("parsedDetails---", parsedDetails);
      // console.log("services---", services);
      // if (parsedDetails.service) {
      //   setSpecializationName(parsedDetails.service);
      // }
      setSavedValues(parsedDetails);
      if (parsedDetails.profileImage) {
        setFileName("Profile image uploaded");
      }
    }
  }, [services]);

  // console.log("selectedService-----------", selectedService);

  useEffect(() => {
    refreshVendorData();
    get_services();
  }, []);

  useEffect(() => {
    if (vendor) {
      setServiceId(vendor.service);
      setFeeRange({
        fee_from: vendor.fee_from || "",
        fee_to: vendor.fee_to || "",
      });
    } else {
      setFeeRange({ fee_from: "", fee_to: "" });
    }
  }, [vendor]);

  // After services are fetched, map name to ID if needed
  useEffect(() => {
    // if (services.length && specializationName && savedValues) {
    //   const found = services.find((s) => s.name === specializationName);
    //   if (found && savedValues.service !== found.id) {
    //     setSavedValues({ ...savedValues, service: found.id });
    //   }
    // }
  }, [services, specializationName, savedValues]);

  async function get_services() {
    try {
      setIsServicesLoading(true);
      const response = await apicall.get(`get_ezp_service`);
      if (response.status === 200) {
        let s1 = response.data.map((service) => ({
          id: service?.service_id,
          name: service?.service_name,
        }));
        setServices(s1);
        setServicesFetched(true);
      }
    } catch (error) {
      console.error("Error fetching services:", error);
      toast.error("Failed to load services");
    } finally {
      setIsServicesLoading(false);
    }
  }

  const checkUserExists = async (field, value) => {
    try {
      const data = {
        role: 5,
      };

      if (field === "email") {
        data.email = value;
      } else if (field === "phone_number") {
        data.phone_number = value;
      }

      const response = await apicall.post(data, "checkUserExists");

      if (response && response.status === 200) {
        return response;
      } else {
        console.error("Invalid response from checkUserExists:", response);
        return { exists: false };
      }
    } catch (error) {
      console.error("Error checking user existence:", error);
      return { exists: false };
    }
  };

  const handleImageUpload = (event, setFieldValue) => {
    const file = event.target.files[0];
    if (file) {
      if (file.size > IMAGE_SIZE_LIMIT) {
        toast.error("Image file is too large (max 500 KB)");
        return;
      }

      const img = new window.Image();
      img.src = URL.createObjectURL(file);
      img.onload = () => {
        if (
          img.width > IMAGE_DIMENSIONS_WIDTH ||
          img.height > IMAGE_DIMENSIONS_HEIGHT
        ) {
          toast.error("Image dimensions are too large (max 180w x 180h)");
          return;
        }
        setFileName(file.name);
        const reader = new FileReader();
        reader.onloadend = () => {
          const base64String = reader.result;
          setFieldValue("profileImage", base64String.split(",")[1]);
        };
        reader.readAsDataURL(file);
      };
    }
  };

  const debouncedCheckUserExists = useCallback(
    debounce(async (field, value, setFieldError) => {
      try {
        const response = await checkUserExists(field, value);
        if (response?.data?.exists) {
          const fieldName =
            field === "phone_number" ? "mobileNumber" : "emailAddress";
          const fieldLabel =
            field === "phone_number" ? "phone number" : "email";
          setFieldError(fieldName, `This ${fieldLabel} is already registered`);
        }
      } catch (error) {
        console.error(`Error in debounced check for ${field}:`, error);
      }
    }, 500),
    []
  );

  const validationSchema = Yup.object().shape({
    providerName: Yup.string()
      .required("Crew name is required")
      .min(2, "Crew name must be at least 2 characters")
      .max(20, "Crew name cannot exceed 20 characters"),
    // emailAddress: Yup.string()
    //   .matches(
    //     /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
    //     "Invalid email format"
    //   )
    //   .required("Email is required")
    //   .test(
    //     "unique-email",
    //     "This email is already registered",
    //     async function (value) {
    //       if (!value) return true;
    //       try {
    //         const result = await checkUserExists("email", value);
    //         return !result?.data?.exists;
    //       } catch (error) {
    //         return true;
    //       }
    //     }
    //   ),

    mobileNumber: Yup.string()
      .required("Contact number is required")
      .matches(/^[0-9]+$/, "Contact number must be numeric")
      .test("country-specific-length", function (value) {
        if (!value) return true;
        // Remove any non-digit characters
        const cleanedValue = value.replace(/\D/g, "");
        // Check for India
        if (cleanedValue.startsWith("91")) {
          if (cleanedValue.length < 12) {
            return this.createError({
              message:
                "Please enter a valid Indian phone number (min 10 digits)",
            });
          }
        }
        // Check for UAE
        if (cleanedValue.startsWith("971")) {
          if (cleanedValue.length < 12) {
            return this.createError({
              message: "Please enter a valid UAE phone number (min 9 digits)",
            });
          }
        }
        // Default: allow
        return true;
      })
      .test(
        "unique-phone",
        "This phone number is already registered",
        async function (value) {
          if (!value) return true;
          try {
            const result = await checkUserExists("phone_number", value);
            return !result?.data?.exists;
          } catch (error) {
            return true;
          }
        }
      ),

    gender: Yup.string().required("Gender is required"),
    // payRoll: Yup.number()
    //   .required("Payroll is required")
    //   .min(0, "Payroll must be positive")
    //   .test(
    //     "fee-range",
    //     `Fee must be between AED ${feeRange.fee_from} and AED ${feeRange.fee_to}`,
    //     function (value) {
    //       if (!feeRange.fee_from || !feeRange.fee_to) return true;
    //       const fee = Number(value);
    //       const from = Number(feeRange.fee_from);
    //       const to = Number(feeRange.fee_to);
    //       return fee >= from && fee <= to;
    //     }
    //   ),
    // service: Yup.string().required("Service is required"),
    // service: Yup.array()
    //   .min(1, "Select at least one service")
    //   .required("Service is required"),

    // dateOfBirth: Yup.date()
    //   .required("Date of birth is required")
    //   .max(new Date(), "Date of birth cannot be in the future")
    //   .test("min-age", "You must be at least 15 years old", function (value) {
    //     if (!value) return true;
    //     const today = new Date();
    //     const fifteenYearsAgo = new Date(
    //       today.setFullYear(today.getFullYear() - 15)
    //     );
    //     return new Date(value) <= fifteenYearsAgo;
    //   }),
    experienceStartDate: Yup.date()
      .required("Experience start date is required")
      .max(new Date(), "Experience start date cannot be in the future")
      .test(
        "experience-after-dob",
        "Experience start date must be after date of birth",
        function (value) {
          const { dateOfBirth } = this.parent;
          if (!value || !dateOfBirth) return true;
          return new Date(value) > new Date(dateOfBirth);
        }
      ),

    // about: Yup.string()
    //   .required("About section is required")
    //   .min(10, "About section must be at least 10 characters")
    //   .max(500, "About section cannot exceed 500 characters"),
    // uniqueId: Yup.string().required("Unique ID is required"),
    // education: Yup.string().required("Education is required"),
  });

  const handleSubmit = (values, { setSubmitting }) => {
    // Find degree_name for selected education ID

    console.log("selectedService--", selectedService);

    if (selectedService?.length === 0) {
      setServiceError(true);
      setSubmitting(false);
      return;
    }

    let s1 = selectedService.map((serviceId) => serviceId.id);

    const dataToStore = {
      ...values,
      service: s1,
      country: values.country,
    };
    console.log("dataToStore---", dataToStore);

    sessionStorage.setItem("providerDetails", JSON.stringify(dataToStore));
    navigate("/providers/add/availability");
    setSubmitting(false);
  };

  // Add cleanup function for session storage
  useEffect(() => {
    return () => {
      const currentPath = window.location.pathname;
      if (
        !currentPath.includes("/providers/add") &&
        !currentPath.includes("/providers/profile/")
      ) {
        sessionStorage.removeItem("providerDetails");
      }
    };
  }, []);

  const handleNavigation = () => {
    // Clear session storage only when navigating to the main providers list
    if (window.location.pathname === "/providers/add") {
      sessionStorage.removeItem("providerDetails");
    }
    navigate("/providers");
  };

  return (
    <>
      <RotateDevicePopup />
      <div className="px-3">
        <div className="d-flex align-items-center mb-3 pt-3">
          <Button
            variant="link"
            className="text-dark text-decoration-none p-0 d-flex align-items-center"
            onClick={handleNavigation}
            style={{ fontSize: "14px" }}
          >
            <MdArrowBack size={20} /> BACK
          </Button>
        </div>

        <div className="form-container">
          <h4 className="mb-4 page-heading">Add Crew</h4>

          <Formik
            initialValues={savedValues || initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
            enableReinitialize={true}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
              setFieldValue,
              setValues,
              setFieldError,
              setFieldTouched,
            }) => (
              <Form onSubmit={handleSubmit}>
                <div className="mb-4">
                  <h6 className="mb-4 section-heading">Personal Details</h6>
                  <Row className="mb-4">
                    <Col md={4}>
                      <Form.Group>
                        <Form.Label>Crew Name</Form.Label>
                        <Form.Control
                          type="text"
                          name="providerName"
                          placeholder="Enter crew name"
                          value={values.providerName}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          isInvalid={
                            touched.providerName && errors.providerName
                          }
                          className="form-input"
                        />
                        {touched.providerName && errors.providerName && (
                          <Form.Control.Feedback type="invalid">
                            {errors.providerName}
                          </Form.Control.Feedback>
                        )}
                      </Form.Group>
                    </Col>
                    <Col md={4}>
                      <Form.Group>
                        <Form.Label>Gender</Form.Label>
                        <Dropdown
                          name="gender"
                          value={values.gender || null}
                          options={[
                            { label: "Male", value: "male" },
                            { label: "Female", value: "female" },
                          ]}
                          placeholder="Select Gender"
                          onChange={(e) => setFieldValue("gender", e.value)}
                          onBlur={handleBlur}
                          className={`w-100 ${
                            touched.gender && errors.gender ? "is-invalid" : ""
                          }`}
                          style={{
                            borderColor:
                              touched.gender && errors.gender
                                ? "#dc3545"
                                : "#E9ECEF",
                          }}
                          appendTo="self"
                        />

                        {touched.gender && errors.gender && (
                          <div className="invalid-feedback d-block">
                            {errors.gender}
                          </div>
                        )}
                      </Form.Group>
                    </Col>
                    <Col md={4}>
                      <Form.Label>Services</Form.Label>
                      <Form.Group className="mb-3">
                        {/* <Form.Label>Service</Form.Label>
                      <Form.Select
                        name="service"
                        value={values.service}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={touched.service && errors.service}
                        className={` ${
                          values.service === "" ? "placeholder-style" : ""
                        }`}
                        style={{ fontSize: "14px" }}
                      >
                        <option value="">Select Service</option>
                        {isServicesLoading ? (
                          <option disabled>Loading services...</option>
                        ) : (
                          services.map((service) => (
                            <option key={service.id} value={service.id}>
                              {service.name}
                            </option>
                          ))
                        )}
                      </Form.Select>
                      {touched.service && errors.service && (
                        <Form.Control.Feedback type="invalid">
                          {errors.service}
                        </Form.Control.Feedback>
                      )} */}

                        <div>
                          <MultiSelect
                            value={selectedService}
                            onChange={(e) => {
                              setSelectedService(e.value);
                              setServiceError(false);
                            }}
                            options={services}
                            optionLabel="name"
                            filter
                            filterDelay={400}
                            placeholder="Select Service"
                            maxSelectedLabels={3}
                            style={{ width: "100%", height: "40px" }}
                          />
                          {serviceError && (
                            <div className="invalid-feedback d-block">
                              Select Service
                            </div>
                          )}
                        </div>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row className="mb-4">
                    {/* 
                  <Col md={4}>
                    <Form.Group>
                      <Form.Label>Date of Birth</Form.Label>
                      <div className="position-relative">
                        <DatePicker
                          selected={
                            values.dateOfBirth
                              ? new Date(values.dateOfBirth)
                              : null
                          }
                          onChange={(date) =>
                            setFieldValue("dateOfBirth", date)
                          }
                          onBlur={() => setFieldTouched("dateOfBirth", true)}
                          dateFormat="yyyy-MM-dd"
                          maxDate={
                            new Date(
                              new Date().setFullYear(
                                new Date().getFullYear() - 15
                              ) -
                                24 * 60 * 60 * 1000
                            )
                          }
                          placeholderText="Select date of birth"
                          className={`form-control ${
                            errors.dateOfBirth && touched.dateOfBirth
                              ? "is-invalid"
                              : ""
                          }`}
                          showYearDropdown
                          scrollableYearDropdown
                          yearDropdownItemNumber={100}
                          dropdownMode="select"
                          peekNextMonth
                          showMonthDropdown
                        />
                        <IoCalendarOutline
                          className="position-absolute end-1 top-50 translate-middle-y text-secondary pe-none text-dark"
                          style={{
                            right:
                              errors.dateOfBirth && touched.dateOfBirth
                                ? "1.75rem"
                                : "0.75rem",
                          }}
                        />
                        {errors.dateOfBirth && touched.dateOfBirth && (
                          <div
                            className="invalid-feedback d-block"
                            style={{
                              position: "absolute",
                              bottom: "-1.25rem",
                              left: 0,
                              fontSize: "0.875em",
                              color: "#dc3545",
                            }}
                          >
                            {errors.dateOfBirth}
                          </div>
                        )}
                      </div>
                    </Form.Group>
                  </Col> */}

                    <Col md={4}>
                      <Form.Group>
                        <Form.Label>Experience Started On</Form.Label>
                        <div className="position-relative">
                          <DatePicker
                            selected={
                              values.experienceStartDate
                                ? new Date(values.experienceStartDate)
                                : null
                            }
                            onChange={(date) =>
                              setFieldValue("experienceStartDate", date)
                            }
                            onBlur={() =>
                              setFieldTouched("experienceStartDate", true)
                            }
                            dateFormat="yyyy-MM-dd"
                            maxDate={new Date(Date.now() - 24 * 60 * 60 * 1000)}
                            placeholderText="Select start date"
                            className={`form-control ${
                              errors.experienceStartDate &&
                              touched.experienceStartDate
                                ? "is-invalid"
                                : ""
                            }`}
                            showYearDropdown
                            scrollableYearDropdown
                            yearDropdownItemNumber={100}
                            dropdownMode="select"
                            peekNextMonth
                            showMonthDropdown
                          />
                          <IoCalendarOutline
                            className="position-absolute end-1 top-50 translate-middle-y text-secondary pe-none text-dark"
                            style={{
                              right:
                                errors.experienceStartDate &&
                                touched.experienceStartDate
                                  ? "1.75rem"
                                  : "0.75rem",
                            }}
                          />
                          {errors.experienceStartDate &&
                            touched.experienceStartDate && (
                              <div
                                className="invalid-feedback d-block"
                                style={{
                                  position: "absolute",
                                  bottom: "-1.25rem",
                                  left: 0,
                                  fontSize: "0.875em",
                                  color: "#dc3545",
                                }}
                              >
                                {errors.experienceStartDate}
                              </div>
                            )}
                        </div>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Form.Group className="mb-4">
                    <h6 className="mb-4 section-heading">About You</h6>
                    <Form.Control
                      as="textarea"
                      name="about"
                      rows={3}
                      placeholder="Small introduction about you"
                      value={values.about}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      isInvalid={touched.about && errors.about}
                      className="form-input"
                    />
                    {touched.about && errors.about && (
                      <Form.Control.Feedback type="invalid">
                        {errors.about}
                      </Form.Control.Feedback>
                    )}
                  </Form.Group>
                </div>

                <div className="P-4 mb-4">
                  <h6 className="mb-4 section-heading">Contact Details</h6>

                  <Row className="mb-4">
                    <Col md={4}>
                      <Form.Group>
                        <Form.Label>Mobile Number</Form.Label>
                        <PhoneInput
                          country={currency === "INR" ? "in" : "ae"} // default country (can be anything)
                          enableSearch={true}
                          value={values.mobileNumber}
                          onChange={(value, data) => {
                            const cleanedValue = value.replace(/\D/g, "");

                            setFieldValue("mobileNumber", cleanedValue);

                            //  IMPORTANT PART
                            const isoUpper = data.countryCode.toUpperCase();

                            setFieldValue("country", data.dialCode); //  backend (91,971)
                            setFieldValue(
                              "countryIso",
                              data.countryCode.toUpperCase()
                            ); //  UI (IN,AE)

                            setFieldValue("state", "");

                            setFieldTouched("mobileNumber", true, false);

                            if (
                              cleanedValue.length >=
                              data.dialCode.length + 6
                            ) {
                              debouncedCheckUserExists(
                                "phone_number",
                                cleanedValue,
                                setFieldError
                              );
                            }
                          }}
                          inputStyle={{
                            width: "100%",
                            height: "40px",
                            backgroundColor: "white",
                            borderColor:
                              touched.mobileNumber && errors.mobileNumber
                                ? "#dc3545"
                                : "#E9ECEF",
                          }}
                          inputProps={{
                            name: "mobileNumber",
                            required: true,
                          }}
                        />
                        {touched.mobileNumber && errors.mobileNumber && (
                          <div className="invalid-feedback d-block">
                            {errors.mobileNumber}
                          </div>
                        )}
                      </Form.Group>
                    </Col>
                    <Col md={4}>
                      <Form.Group>
                        <Form.Label>Country</Form.Label>
                        <Form.Select
                          name="country"
                          value={values.countryIso || ""}
                          disabled
                        >
                          {values.countryIso && (
                            <option value={values.countryIso}>
                              {
                                Country.getCountryByCode(values.countryIso)
                                  ?.name
                              }
                            </option>
                          )}
                        </Form.Select>
                        {touched.emailAddress && errors.emailAddress && (
                          <Form.Control.Feedback type="invalid">
                            {errors.emailAddress}
                          </Form.Control.Feedback>
                        )}
                      </Form.Group>
                    </Col>
                    <Col md={4}>
                      <Form.Group>
                        <Form.Label>State</Form.Label>
                        <Form.Select
                          name="state"
                          value={values.state}
                          onChange={(e) =>
                            setFieldValue("state", e.target.value)
                          }
                          disabled={!values.country}
                        >
                          <option value="">Select State</option>
                          {values.country &&
                            State.getStatesOfCountry(values.countryIso).map(
                              (state) => (
                                <option key={state.isoCode} value={state.name}>
                                  {state.name}
                                </option>
                              )
                            )}
                        </Form.Select>
                        {touched.emailAddress && errors.emailAddress && (
                          <Form.Control.Feedback type="invalid">
                            {errors.emailAddress}
                          </Form.Control.Feedback>
                        )}
                      </Form.Group>
                    </Col>
                    <Col md={4}>
                      <Form.Group>
                        <Form.Label>Email Address</Form.Label>
                        <Form.Control
                          type="email"
                          name="emailAddress"
                          placeholder="Enter email address"
                          value={values.emailAddress}
                          onChange={(e) => {
                            handleChange(e);
                            const value = e.target.value;
                            setFieldTouched("emailAddress", true, false);

                            if (!value) {
                              setFieldError(
                                "emailAddress",
                                "Email is required"
                              );
                            } else if (
                              !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(
                                value
                              )
                            ) {
                              setFieldError(
                                "emailAddress",
                                "Invalid email format"
                              );
                            } else {
                              setFieldError("emailAddress", undefined);
                              debouncedCheckUserExists(
                                "email",
                                value,
                                setFieldError
                              );
                            }
                          }}
                          onBlur={handleBlur}
                          isInvalid={
                            touched.emailAddress && errors.emailAddress
                          }
                          className="form-input"
                        />
                        {touched.emailAddress && errors.emailAddress && (
                          <Form.Control.Feedback type="invalid">
                            {errors.emailAddress}
                          </Form.Control.Feedback>
                        )}
                      </Form.Group>
                    </Col>
                  </Row>
                </div>

                <div className="mb-4">
                  <h6 className="mb-4 section-heading">Additional Details</h6>

                  <Row className="mb-4">
                    <Col md={4}>
                      <Form.Group>
                        <Form.Label>Payroll</Form.Label>
                        <Form.Control
                          type="text"
                          name="payRoll"
                          placeholder=""
                          value={values.payRoll}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          isInvalid={touched.payRoll && errors.payRoll}
                          className="form-input"
                        />
                        {/* {feeRange.fee_from && feeRange.fee_to && (
                        <small className="text-muted">
                          Range: AED {feeRange.fee_from} - {feeRange.fee_to}
                        </small>
                      )} */}
                        {touched.payRoll && errors.payRoll && (
                          <Form.Control.Feedback type="invalid">
                            {errors.payRoll}
                          </Form.Control.Feedback>
                        )}
                      </Form.Group>
                    </Col>

                    <Col md={4}>
                      <Form.Group>
                        <Form.Label>Unique ID</Form.Label>
                        <Form.Control
                          type="text"
                          name="uniqueId"
                          placeholder="Enter uniqueId"
                          value={values.uniqueId}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          isInvalid={touched.uniqueId && errors.uniqueId}
                          className="form-input"
                        />
                        {touched.uniqueId && errors.uniqueId && (
                          <Form.Control.Feedback type="invalid">
                            {errors.uniqueId}
                          </Form.Control.Feedback>
                        )}
                      </Form.Group>
                    </Col>

                    <Col md={4}>
                      <Form.Group>
                        <Form.Label>Profile Photo</Form.Label>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            borderRadius: "4px",
                            overflow: "hidden",
                            border: "1px solid #E9ECEF",
                          }}
                        >
                          <div
                            style={{
                              padding: "6px 12px",
                              backgroundColor: "#fff",
                              color: "#898989",
                              fontSize: "14px",
                              flex: 1,
                              height: "40px",
                              display: "flex",
                              alignItems: "center",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {fileName || "Upload image"}
                          </div>
                          <label
                            htmlFor="profileImage"
                            style={{
                              backgroundColor: "#C9194A",
                              color: "#fff",
                              padding: "9.5px 12px",
                              cursor: "pointer",
                              fontSize: "14px",
                              whiteSpace: "nowrap",
                            }}
                          >
                            Upload Image
                          </label>
                          <input
                            type="file"
                            accept="image/*"
                            onChange={(e) =>
                              handleImageUpload(e, setFieldValue)
                            }
                            style={{ display: "none" }}
                            id="profileImage"
                          />
                        </div>
                        <div className="mt-2">
                          <label className="text-muted small">
                            Max Size: 500 KB
                            <br />
                            Dimensions: 180w x 180h
                          </label>
                        </div>
                      </Form.Group>
                    </Col>
                  </Row>

                  {/* <Row className="mb-4">
                    <Col md={4}>
                      <Form.Group>
                        <Form.Label>
                          Required Login?
                        </Form.Label>
                        <div className="d-flex gap-2">
                          <Button
                            variant={values.requiredLogin === 'Yes' ? 'outline-danger' : 'outline-secondary'}
                            style={{
                              backgroundColor: values.requiredLogin === 'Yes' ? '#FFF5F7' : 'white',
                              borderColor: values.requiredLogin === 'Yes' ? '#DC3545' : '#CED4DA',
                              color: values.requiredLogin === 'Yes' ? '#DC3545' : '#6C757D',
                              width: '100px',
                              height: '38px',
                              fontSize: '14px'
                            }}
                            onClick={() => setValues({ ...values, requiredLogin: 'Yes' })}
                          >
                            Yes
                          </Button>
                          <Button
                            variant={values.requiredLogin === 'No' ? 'outline-danger' : 'outline-secondary'}
                            style={{
                              backgroundColor: values.requiredLogin === 'No' ? '#FFF5F7' : 'white',
                              borderColor: values.requiredLogin === 'No' ? '#DC3545' : '#CED4DA',
                              color: values.requiredLogin === 'No' ? '#DC3545' : '#6C757D',
                              width: '100px',
                              height: '38px',
                              fontSize: '14px'
                            }}
                            onClick={() => setValues({ ...values, requiredLogin: 'No' })}
                          >
                            No
                          </Button>
                        </div>
                      </Form.Group>
                    </Col>
                  </Row> */}
                </div>

                <div className="d-flex bg-white rounded p-2 mb-0 gap-4">
                  <Button
                    variant="light"
                    onClick={handleNavigation}
                    className="custom-btn btn-large"
                  >
                    Cancel
                  </Button>
                  <Button
                    type="submit"
                    variant="danger"
                    // disabled={isSubmitting}
                    className="custom-btn btn-large"
                  >
                    Next
                  </Button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </>
  );
};

export default AddProvider;
